import { IReferralData } from "@interfaces/user/referral-data";
import { authApi } from "@RTKQuery/basic";
import authAuthApi from "../auth/auth";

const referralsAuthApi = authApi.injectEndpoints({
    endpoints: (build) => ({
        getReferralData: build.query<IReferralData, void>({
            query: () => "referrals",
        }),
        withdrawMoney:  build.mutation<boolean, {amount: number}>({
            query: (body) => ({
                url: "referrals/withdraw/main_balance",
                method: "PUT",
                body
            }),
            async onQueryStarted(args, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;

                    if (data) {
                        dispatch(authAuthApi.util.updateQueryData("getUser", undefined, (draft) => {
                            draft.balance = draft.balance + args.amount;
                        }));
                    }
                } catch { }
            },
        })
    }),
    overrideExisting: false,
})

export const {
    useGetReferralDataQuery,
    useWithdrawMoneyMutation
} = referralsAuthApi;